import { z } from 'zod';
import { meta } from '../meta';

export const ShapePropsSchema = z.object({
  shape: z.enum(['rect', 'circle', 'line']).default('rect').meta(meta({
    label: '形状', setter: 'radio',
    options: [{ label: '矩形', value: 'rect' }, { label: '圆形', value: 'circle' }, { label: '线条', value: 'line' }],
  })),
  fill: z.string().default('#1677ff').meta(meta({ label: '填充色', setter: 'color' })),
  stroke: z.string().default('#000000').meta(meta({ label: '描边色', setter: 'color' })),
  strokeWidth: z.number().min(0).max(50).default(0).meta(meta({ label: '描边宽', setter: 'slider', min: 0, max: 50, step: 1 })),
  radius: z.number().min(0).max(500).default(0).meta(meta({
    label: '圆角', setter: 'slider', min: 0, max: 500, step: 1,
    visible: (p) => p.shape === 'rect',
  })),
});

export type ShapeProps = z.infer<typeof ShapePropsSchema>;
